import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.scss";
import Gallery from "react-photo-gallery";
import { setLike, setUnLike } from "../../api/mySpace";
import GalleryItem from "../GalleryItem";
import useColumn from "../../hook/useColumn";
import GalleryDetail from "@/pages/Gallery/components/GalleryDetail";
import { getPromptDetail } from "@/pages/Gallery/api";
import { ImgAndPromptItemType } from "@/stores/gallery";
import { cloneDeep } from "lodash";
import EmptyContent from "../EmptyContent";
import { observer } from "mobx-react-lite";
import { mySpaceStore } from "../../MySpace/store";
import { albumStore } from "@/modules/album/store";
import { AlbumData } from "@/pages/Gallery/components/Album";

const MyLike: React.FC = () => {
  const [curIdx, setCurIdx] = useState<number>(1);
  const column = useColumn();
  const [detailVisible, setDetailVisible] = useState<boolean>(false);
  const [currentId, setCurrentId] = useState<string | number>("");
  const [curImgDetail, setCurImgDetail] = useState<ImgAndPromptItemType[]>([]);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  const {
    loading: myLikeLoading,
    myLikeNoMore,
    myLikeList,
    setLoading,
    getMyLikeList,
    setMyLikeList,
    updateReelsImgInfo,
  } = mySpaceStore;
  const { fetchAlbums, refreshAlbum } = albumStore;

  useEffect(() => {
    setMyLikeList([]);
    getMyLikeList(curIdx, callback);
    fetchAlbums();
    function callback() {
      setCurIdx(curIdx + 1);
      if (firstLoad) setFirstLoad(false);
    }
  }, []);

  const getDetail = async (id: string, callback: () => void) => {
    const {
      data: { list },
    } = await getPromptDetail({ image_id: Number(id) });
    setCurImgDetail(list);
    callback?.();
  };

  const handleGalleryItemClicked = (id: string) => {
    setCurrentId(id);
    getDetail(id, callback);
    function callback() {
      setDetailVisible(true);
    }
  };

  const handleDetailLike = async (id: number) => {
    // 更新detail 的数据
    const targetIdx = curImgDetail.findIndex((item) => String(item.image_id) == String(id));
    console.log("targetIdx", targetIdx);
    if (targetIdx == -1) return; // error
    const newDetail = cloneDeep(curImgDetail);
    newDetail[targetIdx].is_like = true;
    if (!newDetail[targetIdx].likes) {
      newDetail[targetIdx].likes = 0; // 需要初始化
    }
    newDetail[targetIdx].likes! += 1;
    setCurImgDetail(newDetail);

    // 更新 mylikeList 的数据
    const dataIdx = myLikeList.findIndex((item) => String(item.image_id) == String(id));
    if (dataIdx == -1) return; // 不在当前渲染的数据集里
    const newList = cloneDeep(myLikeList);
    newList[dataIdx].is_like = true;
    newList[dataIdx].likes += 1;
    setMyLikeList(newList);
  };

  const handleDetailCancelLike = (id: number) => {
    // 更新detail 的数据
    const targetIdx = curImgDetail.findIndex((item) => String(item.image_id) == String(id));
    if (targetIdx == -1) return; // error
    const newDetail = cloneDeep(curImgDetail);
    newDetail[targetIdx].is_like = false;
    newDetail[targetIdx].likes! -= 1;
    setCurImgDetail(newDetail);

    // 更新 mylikeList 的数据
    const dataIdx = myLikeList.findIndex((item) => String(item.image_id) == String(id));
    if (dataIdx == -1) return; // 不在当前渲染的数据集里
    const newList = cloneDeep(myLikeList);
    newList[dataIdx].is_like = false;
    newList[dataIdx].likes -= 1;
    setMyLikeList(newList);
  };

  const handleDetailFavoriteChange = (id: number) => {
    const targetIdx = curImgDetail.findIndex((item) => String(item.image_id) == String(id));
    console.log("target idx: ", targetIdx);
    if (targetIdx == -1) return; // 不在当前渲染的数据集里
    const newDetail = cloneDeep(curImgDetail);
    if (newDetail[targetIdx].is_favorites) {
      newDetail[targetIdx].is_favorites = false;
    } else {
      newDetail[targetIdx].is_favorites = true;
    }
    setCurImgDetail(newDetail);

    // 更新 mylikeList 的数据
    const dataIdx = myLikeList.findIndex((item) => String(item.image_id) == String(id));
    if (dataIdx == -1) return; // 不在当前渲染的数据集里
    const newList = cloneDeep(myLikeList);
    if (newList[dataIdx].is_favorites) {
      newList[dataIdx].is_favorites = false;
    } else {
      newList[dataIdx].is_favorites = true;
    }
    setMyLikeList(newList);
  };

  const handleDetailFollowChange = (userId: string, follow: boolean) => {
    const newDetail = cloneDeep(curImgDetail);
    console.log("follow", follow);
    console.log("Detail", newDetail);
    if (!follow) {
      for (let i = 0; i < newDetail.length; i++) {
        newDetail[i].user.is_follow = true;
      }
    } else {
      for (let i = 0; i < newDetail.length; i++) {
        newDetail[i].user.is_follow = false;
      }
    }
    console.log("newDetail", newDetail);
    setCurImgDetail(newDetail);
  };

  const handleDetailClose = () => {
    setDetailVisible(false);
  };

  const handleItemLike = async (id: string, idx: number) => {
    const res = await setLike({ image_id: id });
    if (res.code == 0) {
      const newList = cloneDeep(myLikeList);
      newList[idx].is_like = true;
      newList[idx].likes += 1;
      setMyLikeList(newList);
    }
  };

  const handleItemUnCancelLike = async (id: string, idx: number) => {
    const res = await setUnLike({ image_id: id });
    if (res.code == 0) {
      const newList = cloneDeep(myLikeList);
      newList[idx].is_like = false;
      newList[idx].likes -= 1;
      setMyLikeList(newList);
    }
  };

  const imgRender = useCallback(
    ({ index, left, top, key, photo }: any) => (
      <GalleryItem
        key={key}
        photo={photo}
        top={top}
        left={left}
        itemIdx={index}
        handleItemClicked={handleGalleryItemClicked}
        handleLike={handleItemLike}
        handleUnlike={handleItemUnCancelLike}
        type="LIKE"
      />
    ),
    [myLikeList],
  );

  const addMore = () => {
    getMyLikeList(curIdx, callback);
    function callback() {
      setCurIdx(curIdx + 1);
    }
  };

  const onAlbum = (type: number, albumData: AlbumData) => {
    getDetail(String(albumData.image_id), () => null);
  };

  console.log(
    "aa",
    !myLikeLoading,
    myLikeList.length === 0,
    !firstLoad,
    !myLikeLoading && myLikeList.length === 0 && !firstLoad,
  );

  return (
    <div className={styles["my-like-wrapper"]}>
      {myLikeList.length >= 1 && (
        <Gallery
          columns={column}
          renderImage={imgRender}
          direction="column"
          margin={0}
          photos={myLikeList}
        />
      )}
      {!myLikeLoading && !firstLoad && (
        <div className={styles["add-more-wrapper"]}>
          {!myLikeNoMore && myLikeList.length !== 0 && (
            <button onClick={addMore} className={styles["add-more-btn"]}>
              加载更多
            </button>
          )}
          {myLikeNoMore && myLikeList.length !== 0 && (
            <div className={styles["no-more"]}>没有更多了</div>
          )}
        </div>
      )}
      {!myLikeLoading && myLikeList.length === 0 && !firstLoad && <EmptyContent />}
      {detailVisible && (
        <div className={styles["detail-wrapper"]}>
          <GalleryDetail
            currentID={currentId}
            onClose={handleDetailClose}
            previewList={curImgDetail}
            onLike={handleDetailLike}
            onCancelLike={handleDetailCancelLike}
            onFollow={handleDetailFollowChange}
            onAlbum={onAlbum}
            store={albumStore}
          />
        </div>
      )}
    </div>
  );
};

export default observer(MyLike);
